import { render, staticRenderFns } from "./EventDescriptionForm.vue?vue&type=template&id=49a5066b&"
import script from "./EventDescriptionForm.vue?vue&type=script&lang=js&"
export * from "./EventDescriptionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports